import { getGlobals } from '@/lib/globals';

export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 64;
export const BAU_PASSWORD_MAX_LENGTH = 20;

/**
 * Printable ASCII including space (bang through tilde, plus space itself).
 * Space is carved out of this check and flagged separately via
 * `BLANK_SPACE_REG_EX` so it gets its own hint instead of the generic
 * unsupported-character one.
 */
export const PRINTABLE_ASCII_OR_SPACE_REG_EX = /^[\x20-\x7E]*$/;

/** Matches a literal space anywhere in the value. */
export const BLANK_SPACE_REG_EX = / /;

/** At least one Latin letter (A–Z / a–z). */
export const LETTER_REG_EX = /[A-Za-z]/;

/**
 * Reads globals directly instead of reusing `hasTreatment` from
 * `@/lib/features/utils`: that module pulls in `@checkout/react-components`,
 * which webpack resolves back into this directory's own validation files,
 * creating a real circular dependency (confirmed via a `yarn size` build
 * failure). Code outside this directory can use `hasTreatment` safely.
 */
export const isCpcsIntegrationEnabled = (): boolean => {
  const treatment =
    getGlobals().experiments?.FEATURE_WEASLEY_CPCS_INTEGRATION_ENABLED
      ?.treatmentName;

  return typeof treatment === 'string' && treatment.startsWith('Trmt_');
};

export const getPasswordMaxLength = (): string =>
  isCpcsIntegrationEnabled()
    ? String(PASSWORD_MAX_LENGTH)
    : String(BAU_PASSWORD_MAX_LENGTH);
